import { render, staticRenderFns } from "./BookModal.vue?vue&type=template&id=5fbf306b&scoped=true&"
import script from "./BookModal.vue?vue&type=script&lang=js&"
export * from "./BookModal.vue?vue&type=script&lang=js&"
import style0 from "./BookModal.vue?vue&type=style&index=0&id=5fbf306b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf306b",
  null
  
)

export default component.exports